import { useDispatch } from "react-redux";
import { setTopMovies } from "../utils/store/slice/movieSlice";
import { TMDBOptions } from "../utils/tmdbOption";
import { useEffect } from "react";

const UseTopMovies = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  const getData = () => {
    fetch(
      `https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1`,
      TMDBOptions
    )
      .then((res) => res.json())
      .then((data) => {
        dispatch(setTopMovies(data.results));
      });
  };
};

export default UseTopMovies;
